import {ReviewAdditionalDataType} from '../../../../../../../service/reviews/reviews-type';

export function getReviewAdditionalDataTagLabels(
    additionalData: ReviewAdditionalDataType | null | undefined
): Array<string> {
    if (!additionalData) {
        return [];
    }

    const {appVersion, deviceModel, osVersion, appName, locale} = additionalData;
    const labels: Array<string> = [];

    if (appVersion) {
        labels.push(`App version: ${appVersion}`);
    }

    if (deviceModel) {
        labels.push(`Device: ${deviceModel}`);
    }

    if (osVersion) {
        labels.push(`OS version: ${String(osVersion)}`);
    }

    if (appName) {
        labels.push(`App name: ${appName}`);
    }

    if (locale) {
        labels.push(`Locale: ${locale}`);
    }

    return labels;
}
